define([
	"dojo/_base/declare",
	"SiteAdmin/Locale",
	"./Renderer"
], function(declare,Locale,Renderer) {

	return declare(Renderer, {
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			return Locale.getConfigurableAttributeNodeName(ctx.getNode());
		}
	});
});